import React from 'react';

import ReferenceDataProvider from '~/utils/reference-data/context';
import EventTypeName from '~/components/Hl7SiuMap/EventTypeNameField';
import ReminderData from '~/components/Hl7SiuMap/ReminderDataField';

const Hl7SiuMap = () => (
  <ReferenceDataProvider
    type="ReferenceHl7SiuMap"
    config={{
      customFields: {
        eventTypeName: {
          component: EventTypeName,
          initialValue: undefined,
        },
        reminderData: {
          component: ReminderData,
            initialValue: '{"add": ""}',
        },
      },
  }}
  />
);

export default Hl7SiuMap;
